module.exports = __webpack_public_path__ + "img/i_homework-checked.bc273aa5.svg";